import React, { Component } from 'react';

class getTimerCajaActiva extends Component {

componentWillUnmount () {
   clearInterval(this.timer)
 }
 tick () {
   //this.setState({count: (this.state.count + 1)})
   console.log("verificar_caja_activa");
   this.props.validar_caja_activa();
 }
 startTimer () {
   clearInterval(this.timer)
   this.timer = setInterval(this.tick.bind(this), 3000)
 }
 stopTimer () {
   clearInterval(this.timer)
 }
 render () {
   return (
     <React.Fragment>
     </React.Fragment>
   )
 }
 componentDidUpdate (){
  this.startTimer ();
 }
}
 export default getTimerCajaActiva;
